export const selectCharges = state => Object.values(state.charges.items) || [];

export const selectChargePaginate = state => state.charges.paginate || {};

export const selectChargesLoading = state => state.charges.isLoading;
